import { Typetache } from './../models/typetache.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { throwError } from 'rxjs';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'access_token',
  }),
};
@Injectable({
  providedIn: 'root',
})

export class TypeTacheService {
    baseUrl: string = environment.apiUrl;

    constructor(private httpClient: HttpClient) { }

    get_typetache() {
      return this.httpClient.get(this.baseUrl + '/typeTache');
    }
    update_typetache(typetache: Typetache){
      return this.httpClient.put<Typetache>(this.baseUrl + '/typeTache/update/' + typetache.id, typetache, httpOptions)
      .catch((error: any) => {
        return throwError(error);
      });
    }
}